// extracted by mini-css-extract-plugin
export var compactFilters = "_fw-4";
export var detailImage = "_fw-1";
export var dropdownContainer = "_fw-2";
export var imageContainer = "_fw-0";
export var selectedCard = "_fw-3";